import React from 'react';

/* eslint-disable react/prop-types */
export default function ({ color }) {
  // viewBox="0 0 18 18"
  return (
    <path
      fill={color}
      d="M14.83.67H6.5A2.5 2.5 0 0 0 4 3.17V4h-.83a2.5 2.5 0 0 0-2.5 2.5v8.33a2.5 2.5 0 0 0 2.5 2.5h8.33a2.5 2.5 0 0 0 2.5-2.5V14h.83a2.5 2.5 0 0 0 2.5-2.5V3.17a2.5 2.5 0 0 0-2.5-2.5Zm-2.5 14.16a.83.83 0 0 1-.83.84H3.17a.83.83 0 0 1-.84-.84V9h10v5.83Zm0-7.5h-10V6.5a.83.83 0 0 1 .84-.83h8.33a.83.83 0 0 1 .83.83v.83Zm3.34 4.17a.83.83 0 0 1-.84.83H14V6.5c0-.28-.05-.57-.15-.83h1.82v5.83Zm0-7.5h-10v-.83a.83.83 0 0 1 .83-.84h8.33a.83.83 0 0 1 .84.84V4Z"
    />
  );
}
